import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CpMarketplaceApiService } from '../../services/cp-marketplace-api.service';
import { ISSUER_MESSAGES } from 'src/app/messages';
import { AllDocsAdditionalData, DocumentAdditionalDataValidity, DocumentKeys } from 'appRootPath/models/commercial-papers.model';
import { API_DATE_FORMAT, DOCUMENT_NAME_MAP, UI_DATE_FORMAT_MAP } from 'appRootPath/shared/global-meta-data';
import { getCalendarDateObj, getDateFromCalendarObj, isWeekendAndHolidayDisabled } from 'appRootPath/utils';
import * as moment from 'moment';
import { CpDocumentationActionsService } from 'appRootPath/services/cp-documentation-actions.service';
import { OnboardingApiService } from 'appRootPath/onboarding/onboarding-api.service';

@Component({
  selector: 'app-date-additional-data',
  templateUrl: './date-additional-data.component.html',
  styleUrls: ['./date-additional-data.component.scss']
})
export class DateAdditionalDataComponent implements OnInit {
  docDateForm: FormGroup;
  fileTypes: any = ['.xlsx', '.xls'];
  @Input() docKey: DocumentKeys;
  @Input() issueId;
  @Input() prefillData: DateAdditionalData;
  @Input() docDateValidityMap: DocumentAdditionalDataValidity | null;

  documentNameMap = DOCUMENT_NAME_MAP;

  looDateObj;
  looDateFormatted;
  issueValueDateObj;
  issueValueDateFormatted;
  isWeekendAndHolidayDisabled = isWeekendAndHolidayDisabled;


  constructor(
    private docDateFB: FormBuilder,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private apiService: CpMarketplaceApiService,
    private documentationService: CpDocumentationActionsService,
    private onboardingServices: OnboardingApiService
  ) { }

  /**
   * Init Lifecycle hook
   */
  ngOnInit() {
    this.initDocDateForm();
    [this.looDateFormatted, this.looDateObj, this.issueValueDateFormatted, this.issueValueDateObj] =
      this.documentationService.initDatesForValidation(this.docDateValidityMap);
  }

  /**
   * Initialises Doc Date Form Form with the prefil data if it exists.
   */
  initDocDateForm() {
    this.docDateForm = this.docDateFB.group({
      document_date: (this.prefillData && this.prefillData.document_date) ?
        getCalendarDateObj(moment(this.prefillData.document_date).toDate()) :
        null
    });
  }

  /**
   * Post the additional data for the current issue ID and document to the server
   */
  postDocDateAdditionalData(docDateFormData: DateAdditionalData) {
    if (this.docDateForm.invalid) {
      this.toastr.warning(ISSUER_MESSAGES.INVALID_FORM);
    } else {
      docDateFormData.document_date =
        getDateFromCalendarObj(docDateFormData.document_date).format(API_DATE_FORMAT);
      const docAdditionalData = {
        issue: this.issueId,
        [this.docKey]: docDateFormData
      };

      this.apiService.postAdditionalData(docAdditionalData).
        subscribe((res: AllDocsAdditionalData) => {
          if (res.id) {
            this.toastr.success(ISSUER_MESSAGES.DOC_DATE_ADDITIONAL_DATA + this.documentNameMap[this.docKey]);
            this.activeModal.close(res[this.docKey]);
          }
        });
    }
  }

  downloadAddExcel() {
    window.open('/assets/files/Residual Maturity Profile.xlsx','_blank')
  }

  uploadDocument(fileContent, documentName, Optype) {
      const formDataRequest = new FormData();
      formDataRequest.append('files', fileContent);
      formDataRequest.append('type', Optype);
      this.onboardingServices.uploadFileAndGetToken(formDataRequest).subscribe( (respKey) => {
        this.onboardingServices.uploadDataFile({
          file: respKey[0],
          type: Optype
        }, 'MATURITY').subscribe((resp) => {
          this.toastr.success(`${documentName} Added`);
        });
      });
  }
  deleteMaturityData(optype){
    const reqDict= new FormData();
    reqDict.append('type', optype)
    this.onboardingServices.deleteMaturityData(reqDict).subscribe((resp) => {
          this.toastr.success("Successful. Please Proceed");
        });
  }

}

interface DateAdditionalData {
  document_date: string;
}
